import { isLikelyShipmentId, parseShipmentIdFromSearch } from './publicTrackRoute.js';

/**
 * Parse shipment ID from a QR payload (tracking URL, query param, or plain ID).
 * Mirrors backend parse_shipment_id_from_qr_data.
 */
export function parseShipmentIdFromQrData(raw) {
  const text = String(raw || '').trim();
  if (!text) return '';

  const lowered = text.toLowerCase();
  if (lowered.includes('shipment_id=') || lowered.includes('consignment_no=') || /(^|[?&])id=/.test(lowered)) {
    const match = text.match(/(?:shipment_id|consignment_no|(?:^|[?&])id)=([^&\s#]+)/i);
    if (match?.[1]) {
      const candidate = decodeURIComponent(match[1]).trim();
      if (isLikelyShipmentId(candidate)) return candidate;
    }
    try {
      const query = text.includes('?') ? text.split('?').slice(1).join('?') : text;
      const params = new URLSearchParams(query.startsWith('?') ? query : `?${query}`);
      for (const key of ['shipment_id', 'shipmentId', 'consignment_no', 'id']) {
        const value = params.get(key);
        if (value && isLikelyShipmentId(value)) return value.trim();
      }
    } catch {
      // fall through
    }
  }

  if (text.includes('://') || text.startsWith('/')) {
    try {
      const url = text.includes('://') ? new URL(text) : new URL(`https://local${text.startsWith('/') ? '' : '/'}${text}`);
      const segment = decodeURIComponent((url.pathname || '').split('/').filter(Boolean).pop() || '').trim();
      if (isLikelyShipmentId(segment)) return segment;
      const fromQuery = parseShipmentIdFromSearch(url.searchParams);
      if (fromQuery) return fromQuery;
    } catch {
      // fall through
    }
  }

  if (isLikelyShipmentId(text)) return text;
  return '';
}

export function parseShipmentIdsFromQrPayloads(payloads) {
  const list = Array.isArray(payloads) ? payloads : [payloads];
  const seen = new Set();
  const ids = [];
  for (const payload of list) {
    const id = parseShipmentIdFromQrData(payload);
    if (id && !seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  return ids;
}
